import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <div className="hero-badge">
          <img src={`${process.env.PUBLIC_URL}/lasalle_logo.JPG`} alt="La Salle" className="hero-badge-logo" />
          <span>DAM - 1r Curs</span>
        </div>
        <h1 className="hero-title">
          Guia completa de <span className="highlight">Git</span>, <span className="highlight">GitHub</span> i <span className="highlight">GitLab</span>
        </h1>
        <p className="hero-subtitle">
          Tutorial pas a pas: des de la instal·lacio fins al treball col·laboratiu.
          Tot el que necessites per dominar el control de versions.
        </p>
        <div className="hero-actions">
          <a href="#instalacio" className="btn btn-primary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14M5 12l7 7 7-7"/>
            </svg>
            Comenca la guia
          </a>
          <a href="#videos" className="btn btn-secondary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
            Video tutorials
          </a>
        </div>
        <div className="hero-toc">
          <h3>Contingut de la guia</h3>
          <div className="toc-grid">
            <a href="#instalacio" className="toc-item">
              <span className="toc-num">01</span>
              <span>Instal·lacio i configuracio</span>
            </a>
            <a href="#que-es-git" className="toc-item">
              <span className="toc-num">02</span>
              <span>Git vs GitHub vs GitLab</span>
            </a>
            <a href="#workflow" className="toc-item">
              <span className="toc-num">03</span>
              <span>Com funciona Git</span>
            </a>
            <a href="#primer-repo" className="toc-item">
              <span className="toc-num">04</span>
              <span>Primer repositori pas a pas</span>
            </a>
            <a href="#comandos" className="toc-item">
              <span className="toc-num">05</span>
              <span>Comandes essencials</span>
            </a>
            <a href="#branching" className="toc-item">
              <span className="toc-num">06</span>
              <span>Branching i merging</span>
            </a>
            <a href="#github" className="toc-item">
              <span className="toc-num">07</span>
              <span>GitHub: col·laboracio</span>
            </a>
            <a href="#videos" className="toc-item">
              <span className="toc-num">08</span>
              <span>Video tutorials</span>
            </a>
          </div>
        </div>
      </div>
      <div className="hero-visual">
        <div className="terminal-window">
          <div className="terminal-header">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
            <span className="terminal-title">terminal</span>
          </div>
          <div className="terminal-body">
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">git init el-meu-projecte</span>
            </div>
            <div className="terminal-line output">Initialized empty Git repository</div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">cd el-meu-projecte</span>
            </div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">git add .</span>
            </div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">git commit -m "primer commit!"</span>
            </div>
            <div className="terminal-line output success">[main] primer commit!</div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">git remote add origin https://github.com/...</span>
            </div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cmd">git push -u origin main</span>
            </div>
            <div className="terminal-line output success">Branch 'main' set up to track remote</div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="cursor">|</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
